import * as MuiColors from '@mui/material/colors';
import { hexToRgb } from 'common/utilities/colors/colors';
import type { Color } from 'common/utilities/colors/colors.types';

/**
 * Using Material Design palette system implemented by MUI https://mui.com/material-ui/customization/color/
 * Extract three colors from 16 available palettes (excluding yellow) to use for charts visualizations.
 */
export const colorPalette = [
  MuiColors.amber[800],
  MuiColors.lightGreen[800],
  MuiColors.blueGrey[800],
  MuiColors.cyan[800],
  MuiColors.deepOrange[800],
  MuiColors.brown[800],
  MuiColors.teal[800],
  MuiColors.blue[800],
  MuiColors.deepPurple[800],
  MuiColors.green[800],
  MuiColors.grey[800],
  MuiColors.indigo[800],
  MuiColors.lime[800],
  MuiColors.orange[800],
  MuiColors.pink[800],
  MuiColors.lightBlue[800],
  MuiColors.purple[800],
  MuiColors.red[800],

  MuiColors.amber[500],
  MuiColors.lightGreen[500],
  MuiColors.blueGrey[500],
  MuiColors.cyan[500],
  MuiColors.deepOrange[500],
  MuiColors.brown[500],
  MuiColors.teal[500],
  MuiColors.blue[500],
  MuiColors.deepPurple[500],
  MuiColors.green[500],
  MuiColors.grey[500],
  MuiColors.indigo[500],
  MuiColors.lime[500],
  MuiColors.orange[500],
  MuiColors.pink[500],
  MuiColors.lightBlue[500],
  MuiColors.purple[500],
  MuiColors.red[500],

  MuiColors.amber[300],
  MuiColors.lightGreen[300],
  MuiColors.blueGrey[300],
  MuiColors.cyan[300],
  MuiColors.deepOrange[300],
  MuiColors.brown[300],
  MuiColors.teal[300],
  MuiColors.blue[300],
  MuiColors.deepPurple[300],
  MuiColors.green[300],
  // MuiColors.grey[300],
  MuiColors.indigo[300],
  MuiColors.lime[300],
  MuiColors.orange[300],
  MuiColors.pink[300],
  MuiColors.lightBlue[300],
  MuiColors.purple[300],
  MuiColors.red[300],
].map((c) => hexToRgb(c) as Color);

export const defaultColors: Color[] = colorPalette;

export const defaultColor = hexToRgb(MuiColors.deepPurple[500]) as Color;

export const disabledColor = [100, 100, 100] as Color;

export const chartLineColor = MuiColors.deepPurple[500];

export const selectedPointBorderColor = 'rgba(255, 0, 0, 0.8)';
